export class Contact {
  public initials: string;
  public firstName: string;
  public prefix: string;
  public surname: string;

  public gender: string;

  public emailAddress: string;

  public locale: string;

  public subscribe: boolean = true;
  public subscribes: string[];
  public knownFrom: string;

  public toString(): string {
    let resp: string = '';

    resp += 'firstName:' + this.firstName;
    resp += ', prefix:' + this.prefix;
    resp += ', surname:' + this.surname;
    resp += ', gender:' + this.gender;

    return resp;
  }
}
